import { createPortal } from 'react-dom';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { store } from '@/Infrastructure/State';
import { removeGiftCard } from '@/modules/cart/infrastructure/CartReduxRepository';
import { CardButton, ModalWrapper } from '@/modules/perseo-billing/components';
import { setIsGiftCardModalRemoveOpen } from '@/modules/perseo-billing/store/slices/billing';
import {
  Card,
  Divider,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';

export const ModalRemoveGiftCard = () => {
  const billing = useAppSelector((state) => state.billing);
  const cart = useAppSelector((state) => state.cart);
  const { isGiftCardModalRemoveOpen } = billing || {};

  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery('lg');

  const handleRemoveGiftCard = async (): Promise<void> => {
    store.dispatch(removeGiftCard());
    dispatch(setIsGiftCardModalRemoveOpen(false));
  };

  const modalContent = (
    <ModalWrapper
      size="sm"
      roundedType="FIXED_BOTTOM"
      open={isGiftCardModalRemoveOpen}
      onClose={() => dispatch(setIsGiftCardModalRemoveOpen(false))}
      fullWidth={isMobile}
    >
      <Card>
        <div className="co-p-4 co-flex co-flex-col co-gap-4">
          <div className="co-flex co-items-center co-gap-2">
            <Icon
              className="co-flex-shrink-0"
              icon="AlertCircleIconV2"
              width={20}
              height={20}
            />
            <Typography size="h3" weight="semibold">
              ¿Quieres eliminar esta Gift Card?
            </Typography>
            <div
              className="co-ml-auto co-cursor-pointer co-text-gray-500 hover:co-text-gray-800"
              onClick={() => dispatch(setIsGiftCardModalRemoveOpen(false))}
            >
              <Icon icon="CloseIcon" color="black" width={20} height={20} />
            </div>
          </div>

          <Divider />

          <Typography size="h3" className="co-text-pds-neutral-600">
            Se borrará el saldo de esta Gift Card en tu monto total.
          </Typography>

          <CardButton
            fullWidth
            variant="contained"
            onClick={handleRemoveGiftCard}
            loading={cart.isLoading}
            color="pds-error"
          >
            Eliminar
          </CardButton>

          <CardButton
            fullWidth
            rounded="full"
            variant="outlined"
            color="primary"
            onClick={() => dispatch(setIsGiftCardModalRemoveOpen(false))}
          >
            Cancelar
          </CardButton>
        </div>
      </Card>
    </ModalWrapper>
  );

  const rootGiftCardRemove = document.getElementById('modal-giftcard-remove');
  return rootGiftCardRemove && createPortal(modalContent, rootGiftCardRemove);
};
